export default __webpack_public_path__ + "static/media/hhs-qld-darling-downs.0d0ea767.svg";